namespace GeniuzPOS.Inventory {
    export enum ApproveFgSelect {
        ApproveFgSelect = 0,
        ApproveFgSelect1 = 1,
        sendApproveFg = 2
    }
    Serenity.Decorators.registerEnumType(ApproveFgSelect, 'GeniuzPOS.Inventory.ApproveFgSelect', 'Inventory.ApproveFgSelect');
}
